import { Box, Stack, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import $ from 'jquery';
import NavView from '../component/NavView';
import PageFooter from './PageFooter';
import SectionView from '../component/home/SectionView';
import { getImgPath } from '../store/JSTool';
import { useParams, useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import * as APJHttp from '../store/APJHttp';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';

const cacheMap = new Map();

export default function NewsDetailPage() {

    let navId = 'news_detail_page_nav';
    let pageId = 'news_detail_page_div';
    let sectionIdAry = ['news_detail_news'];

    const navigate = useNavigate();
    const dispatch = useDispatch();

    let params = useParams();             //newsDetail/:pathParam
    let { state, search } = useLocation(); //{state:{x:x}}
    let [searchParams, setSearchParams] = useSearchParams();
    const [content, setContent] = React.useState('');


    React.useEffect(() => {
        dispatch(settingActions.setNavIndex(2));
        JSTool.addPageScrollListener(pageId, navId, 0, sectionIdAry);

        const id = searchParams.get('id'); //新闻id
        if (!JSTool.isEmpty(id)) {
            const x = cacheMap.get(id);
            if (!JSTool.isEmpty(x)) { //缓存
                setContent(x);
            } else {
                APJHttp.getNewsDetail(id, (data) => {
                    setContent(data.content);
                    cacheMap.set(id, data.content);
                }, (code, msg) => {
                    dispatch(settingActions.showToast(`code ${code}: ${msg}`));
                })
            }
        }
    }, []);

    function allNewsTap() {
        navigate('/newsList');
    }

    return (
        <Stack component={'div'}
            sx={{
                width: 1,
                height: '100vh',
                position: 'relative',
            }}>
            <NavView navId={navId} pageId={pageId} />

            <Stack
                id={pageId}
                component={'div'}
                sx={{
                    width: 1,
                    overflow: 'auto',
                    position: 'relative',
                    alignItems: 'center',
                    minHeight: '100vh',
                }} >

                <Stack sx={{
                    width: 1,
                    bgcolor: 'black'
                }}>
                    <Box
                        component={'img'}
                        src={getImgPath('apj_banner.png')}
                        sx={{
                            opacity: 0.5,
                            width: 1,
                            maxHeight: '300px',
                            minHeight: '150px',
                            objectFit: 'cover',
                        }} />
                </Stack>

                <SectionView id={sectionIdAry[0]} title='News' />

                {/* 灰色详情 */}
                <Stack sx={{
                    width: '950px',
                    bgcolor: '#EBEBEB',
                    borderRadius: '15px',
                    px: 5,
                    pt: 2,
                    pb: 3,
                }}>
                    <Box
                        className='newsDetailContent'
                        component={'div'}
                        sx={{
                            color: 'black',
                        }}
                        dangerouslySetInnerHTML={{
                            __html:
                                `
                                  ${content}
                                `
                        }} />

                </Stack>

                <Box sx={{ flex: 1 }} />

                {/* 按钮 */}
                <Stack
                    onClick={allNewsTap}
                    sx={{
                        mb: 7,
                        height: '60px',
                        minHeight: '60px',
                        minWidth: '210px',
                        bgcolor: 'black',
                        borderRadius: '8px',
                        mt: 5,
                        color: 'white',
                        justifyContent: 'center',
                        alignItems: 'center',
                        cursor: 'pointer',
                        flexDirection: 'row',
                        transitionDuration: '0.3s',
                        '&:hover': {
                            transform: 'scale(1.04)',
                        }
                    }}>
                    <Typography sx={{
                        fontFamily: 'Lexend Deca',
                        fontSize: 19,
                    }}>
                        All News
                    </Typography>

                    <Box component={'img'}
                        src={getImgPath('arrow_right.png')}
                        sx={{
                            ml: 1.5,
                            right: '25px',
                            height: '15px',
                        }} />
                </Stack>

                <PageFooter pageId={pageId} />
            </Stack>
        </Stack>
    );
}
